import { motion } from "framer-motion";

export function LiveBadge({ minute, status }: { minute?: number | null; status?: string | null }) {
  const label =
    status === "HT" ? "HZ" :
    status === "ET" ? "n.V." :
    status === "P" ? "Elfm." :
    status === "BT" ? "Pause" :
    minute != null ? `${minute}'` : "LIVE";
  return (
    <span className="inline-flex items-center gap-1 bg-primary text-primary-foreground rounded-pill px-2 py-1 text-[10px] font-bold uppercase tracking-wider">
      <motion.span
        animate={{ opacity: [1, 0.3, 1] }}
        transition={{ duration: 1.4, repeat: Infinity }}
        className="h-1.5 w-1.5 rounded-full bg-primary-foreground"
      />
      LIVE · {label}
    </span>
  );
}
